import { clone } from 'ramda';

import { EElevators } from '../api-models/common/json_query';

import { resetTerms, setRangeMin, setTerm } from './helpers';
import { EElevatorType, type TJsonQuery } from './types';

export function setElevatorType(jsonQuery: TJsonQuery) {
  return (elevatorType: EElevatorType | null): TJsonQuery => {
    let nextJsonQuery = clone(jsonQuery);

    nextJsonQuery = resetTerms(['lift_service', 'lifts'])(nextJsonQuery);

    if (elevatorType) {
      switch (elevatorType) {
        case EElevatorType.Any:
          nextJsonQuery = setTerm('lifts')(nextJsonQuery)(EElevators.One);
          break;
        case EElevatorType.Service:
          nextJsonQuery = setRangeMin('lift_service')(nextJsonQuery)(1);
          break;
      }
    }

    return nextJsonQuery;
  };
}
